import { smoothScroll } from "./smooth-scroll";

$(function () {

  $('a[href*="#"]:not([href="#"],[data-toggle])').on('click', function (event) {
    const target = event.target;

    // Make sure the link is on the same page
    if (
      location.pathname.replace(/^\//, '') == target.pathname.replace(/^\//, '') &&
      location.hostname == target.hostname
    ) {
        smoothScroll(target);
    } else {
      return true;
    }
  });

})
